import * as React from "react";
import { Grid, Box, Paper, Typography, Container } from "@mui/material";
// import { RecordContextProvider, useListContext } from 'react-admin';
import features from '../helpers/features.json';

const LoadingGridList = (props) => (
  <Box
    border={1}
    borderColor="#ddd"
    borderRadius="5px"
    p={4}
    bgcolor="white"
    color="#000"
    className="feature_blocks"
    fontSize={20}
    gap={0}
    data-aos="zoom-in"
  >
    <h4>{props.title}</h4>
    <Typography fontSize={16}>
      {props.description}
    </Typography>
  </Box>
);

export const Features = () => {
  
  return (
    <>
      <Grid container className="Features" py={5} bgcolor="#fbfbfb">
        <Container maxWidth="lg">
          <h2 className="text-center mt-0">Features</h2>

          <Typography mb={5} fontSize={14} textAlign="center">
            MoneyTrek is a finance traking application that makes management of money and Budget
            easy.
            <br />
            The app helps individuals and businesses to track and manage their expenses.
          </Typography>

          <Grid container spacing={4}>
            {features && (
              <>
              {features.map((data, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <LoadingGridList title={data.title} description={data.description} />
                  </Grid>
              ))}
              </>
            )}
            {/* <Grid item xs={12} md={6} lg={4}>
              <LoadingGridList />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LoadingGridList />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LoadingGridList />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LoadingGridList />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LoadingGridList />
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
    </>
  );
};
